<template>
    <div class="tables-home">
        <div class="route-page-content">
            <SidebarChild :items="menuItems" :focusActive="true" @selected="handleSidebarSelection" />
            <div class="page-content-wrapper">
                <h3 class="title">{{ $t("tables.tables") }}</h3>

                <div class="table-wrapper">
                    <div class="toolbar">
                        <div class="left">
                            <a-input-search
                                style="width: 300px"
                                v-model="searchText"
                                :placeholder="$t('message.startFilter')"
                                class="row search-input"
                                @search="onSearch"
                            />
                        </div>
                        <div class="right">
                            <SupsisButton primary @click="createTable">
                                <i class="material-icons">add</i>
                                {{ $t("message.newTable") }}
                            </SupsisButton>
                        </div>
                    </div>

                    <SupsisTable
                        :columns="getCols()"
                        :rows="filteredTables"
                        :top-pagination="true"
                        empty-data-bordered
                        :bottom-pagination="true"
                        :pagination-cursor="pagination"
                        :options="{
                            rowStyleOption,
                            clipboardOption,
                            fixedHeader: true,
                            id: 'tables-table',
                            borderX: true,
                            borderY: true,
                        }"
                        @cursor-changed="(cursor) => (pagination = cursor)"
                    />
                </div>

                <Modal2
                    v-if="showCreateModal"
                    @cancel="showCreateModal = false"
                    :showFooter="false"
                    :title="$t('tables.createTable')"
                >
                    <CreateTable @create="handleCreateTable" />
                </Modal2>

                <Modal2
                    v-if="showEditModal"
                    @cancel="showEditModal = false"
                    :showFooter="false"
                    title="Tabloyu Düzenle"
                >
                    <EditTable :table="editingTable" @update="handleUpdateTable" />
                </Modal2>
            </div>
        </div>
    </div>
</template>

<script>
import { TABLE_API } from "../../../api/table";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import SupsisTable from "../../../components/SupsisTable.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";
import CommonFilterTool from "../Chatbot/pages/archive/CommonFilterTool.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import CreateTable from "./CreateTable.vue";
import EditTable from "./EditTable.vue";

export default {
    name: "TablesHome",
    components: {
        AppBreadCrumb,
        SidebarChild,
        CommonFilterTool,
        SupsisTable,
        SupsisButton,
        Modal2,
        CreateTable,
        EditTable,
    },
    data() {
        return {
            // Değişiklik: selectedTab kaldırıldı
            searchText: '',
            tables: [],
            pagination: {
                page: 1,
                perPage: 20,
                total: 0,
            },
            loading: true,
            rowStyleOption: {
                stripe: true,
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            filterMetas: [],
            breakdownFilter: [],
            // Değişiklik: menuItems eklendi
            menuItems: [
                {
                    enabled: true,
                    key: "all-tables",
                    label: this.$t("tables.allTables"),
                    icon: {
                        type: "material-icons",
                        name: "table_chart",
                    },
                },
                {
                    enabled: true,
                    key: "my-tables",
                    label: this.$t("tables.myTables"),
                    icon: {
                        type: "material-icons",
                        name: "person",
                    },
                },
                {
                    enabled: true,
                    key: "favorites",
                    label: this.$t("tables.myFavorites"),
                    icon: {
                        type: "material-icons",
                        name: "star",
                    },
                },
            ],
            showCreateModal: false,
            newTable: {
                name: "",
                description: "",
            },
            showEditModal: false,
            editingTable: null,
        };
    },
    computed: {
        filteredTables() {
            if (!this.searchText) {
                return this.tables;
            }
            const searchLower = this.searchText.toLowerCase();
            return this.tables.filter(table =>
                table.name.toLowerCase().includes(searchLower) ||
                table.description.toLowerCase().includes(searchLower)
            );
        },
    },
    methods: {
        async fetchTables() {
            try {
                this.loading = true;
                const tables = await TABLE_API.listTables();
                this.tables = tables;
                this.pagination.total = tables.length;
                this.loading = false;
            } catch (error) {
                console.error("Error fetching tables:", error);
                this.loading = false;
            }
        },
        onSearch() {
            this.pagination.page = 1;
        },
        addFilter(name, value) {
            // Implement filter logic
        },
        filterLabelFormatter(name, value) {
            // Implement filter label formatting
        },
        getCols() {
            return [
                {
                    key: "name",
                    field: "name",
                    title: this.$t("message.name"),
                },
                {
                    key: "description",
                    field: "description",
                    title: this.$t("message.description"),
                },
                {
                    key: "createdAt",
                    field: "createdAt",
                    title: this.$t("message.createdAt"),
                    renderBodyCell: ({ row }) => {
                        return this.$moment(row.createdAt).format("DD.MM.YYYY");
                    },
                },
                {
                    key: "actions",
                    field: "actions",
                    title: this.$t("message.actions"),
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="actions">
                                <SupsisButton class="edit-btn" onClick={() => this.editTable(row._id)} icon xxsmall ghost>
                                    <i class="material-icons">edit</i>
                                </SupsisButton>
                                <SupsisButton class="view-btn" onClick={() => this.viewTable(row._id)} icon xxsmall ghost>
                                    <i class="material-icons">visibility</i>
                                </SupsisButton>
                                <SupsisButton
                                    class="delete-btn"
                                    onClick={() => this.deleteTable(row._id)}
                                    icon
                                    xxsmall
                                    danger
                                    ghost
                                >
                                    <i class="material-icons">delete</i>
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ];
        },
        createTable() {
            this.showCreateModal = true;
        },
        async handleCreateTable(data) {
            try {
                await TABLE_API.createTable(data.name, data.description, data.template);
                this.showCreateModal = false;
                this.fetchTables();
            } catch (error) {
                console.error("Error creating table:", error);
            }
        },
        // Değişiklik: handleSidebarSelection metodu eklendi
        handleSidebarSelection(item) {
            // Seçilen menü öğesine göre filtreleme veya başka işlemler yapılabilir
            console.log("Seçilen menü öğesi:", item.key);
        },
        viewTable(tableId) {
            this.$router.push(`/tables/t/${tableId}`);
        },
        async deleteTable(tableId) {
            try {
                await this.$confirm({
                    title: "Tabloyu Sil",
                    content: "Bu tabloyu silmek istediğinizden emin misiniz?",
                    okText: "Evet",
                    okType: "danger",
                    cancelText: "Hayır",
                    onOk: async () => {
                        await TABLE_API.deleteTable(tableId);
                        this.tables = this.tables.filter((table) => table._id !== tableId);
                        this.$message.success("Tablo başarıyla silindi.");
                    },
                });
            } catch (error) {
                console.error("Tablo silinirken hata oluştu:", error);
            }
        },
        editTable(tableId) {
            const table = this.tables.find((table) => table._id === tableId);
            if (table) {
                this.editingTable = { ...table };
                this.showEditModal = true;
            }
        },
        async handleUpdateTable(data) {
            try {
                await TABLE_API.updateTable(this.editingTable._id, data);
                this.showEditModal = false;
                this.fetchTables();
            } catch (error) {
                console.error("Error updating table:", error);
            }
        },
    },
    created() {
        this.fetchTables();
    },
    watch: {
        pagination: {
            handler() {
                this.fetchTables();
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.tables-home {
    .page-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
    }

    .table-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .toolbar {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            gap: 5px;

            .left {
                display: flex;
                gap: 5px;
                align-items: center;
            }

            .right {
                display: flex;
                gap: 5px;
            }
        }
    }

    #tables-table {
        .actions {
            display: flex;
            gap: 5px;
        }
    }
}
</style>
